import React from "react";
import "./index.scss";

const ChromeStoreRating = () => (
  <section className="PgESM-CSR">
    <div className="PgESM-CSR-content">
      <p className="PgESM-CSR-block PgESM-CSR-block_b1">
        <span className="PgESM-CSR-block__title">5M+</span>
        <span className="PgESM-CSR-block__text">
          de productos rentables encontrados
        </span>
      </p>
      <div className="PgESM-CSR__line" />
      <p className="PgESM-CSR-block PgESM-CSR-block_b2">
        <span className="PgESM-CSR-block__title">100+</span>
        <span className="PgESM-CSR-block__text">
          coaches de Amazon la usan para enseñar
        </span>
      </p>
      <div className="PgESM-CSR__line" />
      <p className="PgESM-CSR-block PgESM-CSR-block_b3">
        <span className="PgESM-CSR-block__title">500K+</span>
        <span className="PgESM-CSR-block__text">
          vendedores nos han elegido
        </span>
      </p>
    </div>
  </section>
);

export default ChromeStoreRating;
